module.exports = "https://p.cds.unp.clasificados.pe/logo-peru-21-grey.9f47ba8b9d3b134f1369fb8cc49bcc56.svg";